import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getListData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/listTable', qs.stringify(params));
}

/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getRechargeList = (params) => {
  return axios.post(root + '/recharge/rechargerecord/list', qs.stringify(params));
}

/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const saveData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/save', qs.stringify(params));
}

/**
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const initData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/initData', qs.stringify(params));
}
/**
 * 账户充值、现金收入
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const summary = (params) => {
  return axios.post(root + '/recharge/rechargerecord/summary', qs.stringify(params));
}



// WEBPACK FOOTER //
// ./src/api/set/recharge.js